// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListComputeState_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListComputeState';
  $t: string = 'SagaSchema.ListObjects.ListComputeState';

  public static GetMembers(): string[] {
    return [
      'ComputeStateId',
      'Name',
      'ComputeType',
      'StateDisplayText',
      'StateChoiceList',
      'ComputeProcedure',
      'ComputeParameterList'
    ].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListComputeState_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ComputeStateId: number = 0;
  public Name: string;
  public ComputeType: SagaBase.ComputeStateType;
  public StateDisplayText: string;
  public StateChoiceList: string = '';
  public ComputeProcedure: string;
  public ComputeParameterList: string = '';

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.ComputeStateId;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
